module.exports = __webpack_public_path__ + "mad_slide_tablet.webp";